import { createMuiTheme } from '@material-ui/core/styles';
import styles from './../../assets/styles/default.scss';

const primaryColor = {
  50: styles.primaryColor50,
  100: styles.primaryColor100,
  200: styles.primaryColor200,
  300: styles.primaryColor300,
  400: styles.primaryColor400,
  500: styles.primaryColor500,
  600: styles.primaryColor600,
  700: styles.primaryColor700,
  800: styles.primaryColor800,
  900: styles.primaryColor900,
  A100: styles.primaryColorA100,
  A200: styles.primaryColorA200,
  A400: styles.primaryColorA400,
  A700: styles.primaryColorA700,
  'contrastDefaultColor': styles.primaryColorContrastDefaultColor,
};
const secondaryColor = {
  50: styles.secondaryColor50,
  100: styles.secondaryColor100,
  200: styles.secondaryColor200,
  300: styles.secondaryColor300,
  400: styles.secondaryColor400,
  500: styles.secondaryColor500,
  600: styles.secondaryColor600,
  700: styles.secondaryColor700,
  800: styles.secondaryColor800,
  900: styles.secondaryColor900,
  A100: styles.secondaryColorA100,
  A200: styles.secondaryColorA200,
  A400: styles.secondaryColorA400,
  A700: styles.secondaryColorA700,
  'contrastDefaultColor': styles.secondaryColorContrastDefaultColor,
};

export const LayoutMuiTheme = createMuiTheme({
  typography: {
    fontFamily: '"Nunito", sans-serif',
  },
  palette: {
    primary: primaryColor,
    secondary: secondaryColor
  },
  overrides: {
    MuiAppBar: {
      colorDefault: {
        backgroundColor: '#F00',

      }
    },
    MuiCard: {
      root: {
        padding: 8,
        overflow: 'initial'
      }
    },
    MuiExpansionPanelSummary: {
      root: {
        opacity: '1 !important',
        minHeight: '36px !important',
        borderColor: styles.secondarySicrediLight,
        borderStyle: 'solid',
        borderWidth: '0',
        '&$expanded': {
          minHeight: '36px !important',
          borderWidth: '0 0 1px 0',
        }
      },
      expandIcon: {
        fontSize: '0.8rem !important',
      },
      content: {
        margin: '3px 0 !important',
        alignItems: 'center',
        '&$expanded': {
          margin: '3px 0 !important',
        },
        '@media (max-width: 768px)': {
          flexDirection: 'column',
          alignItems: 'stretch'
        }
      }
    },
    MuiExpansionPanel: {
      root: {
        borderTopLeftRadius: '4px !important',
        borderTopRightRadius: '4px !important',
        borderBottomLeftRadius: '4px !important',
        borderBottomRightRadius: '4px !important',
        overflow: 'hidden',
        margin: '24px 0 ',
        '&&:first-child': {
          marginTop: '0'
        },
        '&&:last-child': {
          marginTop: '0'
        },
        border: 'none',
        '&&:before': {
          content: 'none'
        },
        '&$expanded': {
          borderTopLeftRadius: '4px !important',
          borderTopRightRadius: '4px !important',
          borderBottomLeftRadius: '4px !important',
          borderBottomRightRadius: '4px !important',
          margin: '24px 0 ',
        },
        '&$rounded': {
          borderTopLeftRadius: '4px !important',
          borderTopRightRadius: '4px !important',
          borderBottomLeftRadius: '4px !important',
          borderBottomRightRadius: '4px !important',
        }
      },
    },
    MuiChip: {
      root: {
        height: '28px',
        borderRadius: '18px',
        '&$disabled': {
          opacity: 1
        }
      },
      label: {
        fontSize: '16px',
        lineHeight: '26px',
        fontWeight: 300,
      },
      colorPrimary: {
        backgroundColor: styles.primarySicrediLight,
        color: styles.primarySicrediDark,
        '&$disabled': {
          backgroundColor: styles.secondarySicrediLight,
          color: styles.secondarySicrediDarker
        }
      },
      colorSecondary: {
        backgroundColor: styles.dangerSicrediLight,
        color: styles.dangerSicrediDark,
        '&$disabled': {
          backgroundColor: styles.secondarySicrediLight,
          color: styles.secondarySicrediDarker
        }
      },
    },
    MuiRadio: {
      root: {
        color: styles.primarySicrediDark + ' !important',
        fontFamily: '"Nunito" !important',
        '&$checked': {
          color: styles.primarySicrediDark + ' !important',
        },
        '&$disabled': {
          color: styles.secondarySicredi + ' !important',
        },
        '&&MuiTypography-root': {
          fontFamily: '"Nunito"',
        }
      }
    },
    MuiButton: {
      root: {
        borderRadius: '8px !important',
        padding: '0 !important',
        boxShadow: 'none !important',
        minHeight: '28px',
      },
      startIcon: {
        marginLeft: '0',
        marginRight: '8px',
      },
      endIcon: {
        marginLeft: '8px',
        marginRight: '0',
      },
      iconSizeMedium: {
        '& > *:first-child': {
          fontSize: 16,
        },
      },
      label: {
        fontFamily: '"Nunito"',
        fontWeight: 300,
        fontSize: '16px !important',
        lineHeight: '24px !important',
        textTransform: 'none',
        padding: '2px 8px !important',
      },
    },
    MuiBadge: {
      badge: {
        zIndex: 'initial'
      }
    },
    MuiSelect: {
      root: {
        zIndex: 3
      },
      selectMenu: {
        whiteSpace: "normal"
      }
    },
    MuiFormLabel: {
      root: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '90%',
        lineHeight: '1.3em',
        '&&Mui-focused': {
          maxWidth: '130%',
        },
        '&.Mui-focused': {
          maxWidth: '130%',
        }
      },
      filled: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '130%',
      }
    },
    MuiTooltip: {
      tooltip: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 14,
      },
    },
  }
});